<template>
    <div>
        <div class="table_bg" :style="'max-height:' + height/108 + 'vh'">
            <div class="title">
                <div class="title_left">
                    <div class="icon"></div>
                    <div>设备列表</div>
                </div>
                <div class="close" @click="collapseAll"></div>
            </div>
            <div class="content" id="deviceTableContent">
                <el-tree v-if="showList" :data="list" :props="defaultProps" node-key="id" highlight-current=""
                    :expand-on-click-node='true' ref="elTree" @node-click="handleNodeClick" @node-expand="nodeExpand"
                    @node-collapse="nodeCollapse">
                    <span class="custom-tree-node" slot-scope="{ node }">
                        <span>{{ node.label }}</span>
                        <div style="width: 4vw; font-size:16rem;" v-if="node.childNodes.length < 1">
                            {{getType(node)}}
                        </div>
                        <div style="width: 4vw;" v-if="node.childNodes.length >= 1">{{node.childNodes.length}}台</div>
                    </span>
                </el-tree>
            </div>
        </div>
        <div class="detail" v-show="showDetail" v-drag>
            <div class="head">
                <img :src="currentDevice.deviceImg" class="pic" alt="">
                <div class="data">
                    <div style="font-size:18rem;color:rgba(13, 148, 255, 1)">{{currentDevice.deviceName || '设备名称'}}
                    </div>
                    <div>类型 : {{currentDevice.deviceClassName || ''}}</div>
                    <div>型号 : {{currentDevice.deviceModelName || ''}}</div>
                    <!-- <div>站点 : {{currentDevice.deviceType || ''}}</div> -->
                </div>
                <img class="close" src="../../assets/img/关闭.png" alt="" @click="showDetail = false">
            </div>
            <div class="body">
                <ExpandTable v-for="(value,key,index) in currentDevice.deviceDetails" :key="index" :name="key"
                    :details="value" :modelId="currentDevice.modelId" />
            </div>
        </div>
        <div class="loop" v-show="showLoopTable" v-drag>
            <img class="close" src="../../assets/img/关闭.png" alt="" @click="showLoopTable = false">
            <div class="lineContainer">
                <div class="loopLine" :class="{active:item.modelId == currentLoopModelID}" :key="item.id"
                    v-for="(item) in currentLoopArr"
                    @click="currentLoopModelID = item.modelId, $emit('showLoop',currentDevice.modelId,currentLoopModelID)">
                    <span style="width:70%">{{item.loopName}}</span>
                    <!-- <i>低压回路</i> -->
                    <p v-show="$store.state.projectId != 5">{{($store.state.MQTTObj[item.switchStatus] == 'True' || $store.state.MQTTObj[item.switchStatus] > 0) ? '合闸' : ($store.state.MQTTObj[item.switchStatus] == 'False' || $store.state.MQTTObj[item.switchStatus] == 0 )? '分闸' : '--'}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const TYPE = {
        1: '干式变压器',
        2: '高压开关柜',
        3: '高压馈线柜',
        4: 'Pt柜',
        5: '计量柜',
        6: '高压进线柜',
        8: '油式变压器',
        9: '配电箱',
        10: '单电源进线柜',
        11: '双电源进线柜',
        12: '动力柜',
        13: '无功补偿柜',
        14: '低压馈线柜',
        16: '光伏并网柜',
        17: '低压开关柜',
        18: '枪型摄像头',
        19: '球形摄像头',
        20: '门禁',
        21: '电源进线柜',
        22: '高压出线柜',
        24: '边缘计算机网关',
        25: '有源滤波柜',
        26: '联络柜',
        27: '高清显示主机柜',
        28: '母排柜',
    }
    import ExpandTable from '@/components/ExpandTable'
    import {
        GetDeviceTypeAndInfo,
        GetLoopsByDeviceId,
    } from "@/components/Request";
    import {
        subscribebySubLoopUrl,
        unsubscribebySubLoopUrl
    } from '../../mqtt';

    export default {
        components: {
            ExpandTable
        },
        name: "DeviceTable",
        props: ["areaId"],
        data() {
            return {
                showLoopTable: false,
                showDetail: false,
                height: 0,
                // 设备列表
                showList: false,
                // 当前区域所有设备modelId
                allDeviceModelID: [],
                // 树形设备列表
                list: [],
                // 当前设备信息
                currentDevice: {
                    modelId: '',
                    deviceImg: '',
                    deviceName: '',
                    deviceType: '',
                    deviceDetails: {},
                },
                currentNodeKey: 0,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                modelId: null,

                currentLoopArr: [],
                currentLoopID: '',
                currentLoopModelID: '',
            };
        },
        mounted() {
            GetDeviceTypeAndInfo({
                areaId: this.areaId
            }).then(({
                data
            }) => {
                // console.log(data.data)
                // console.log(data.data.infos.deviceCategories)
                let deviceList = data.data.infos.deviceCategories.find(item => item.deviceCategoryId == 1)
                    .deviceClasses
                // console.log(deviceList)
                let allDeviceModelIDArr = []
                let id = 0
                deviceList.forEach((item1, index1) => {
                    // console.log(item1, index1)
                    this.list[index1] = {
                        id: ++id,
                        label: item1.deviceClassId == 1 ? '变压器' : item1.deviceClassName,
                        children: [],
                    }
                    item1.devices.forEach((item2, index2) => {
                        // console.log(item2);
                        if(item2.deviceTypeId != 36 && item2.deviceTypeId != 37){
                            this.list[index1].children[index2] = {
                                id: ++id,
                                label: item2.deviceName,
                                deviceInfo: item2,
                                modelId: item2.modelId
                            }
                            allDeviceModelIDArr.push({
                                'name': item2.deviceName,
                                'modelId': item2.modelId,
                                'deviceInfo': item2
                            })
                        }
                        
                    })
                })
                this.allDeviceModelID = allDeviceModelIDArr
                // console.log(JSON.stringify(this.allDeviceModelID))
                this.height = this.list.length < 3 ?  1700 : 2200
                this.showList = true
                // console.log(this.list)
            }).catch(err => {
                console.log(err)
            })
        },
        watch: {
            modelId(n, o) {
                if (this.currentLoopArr.length > 0)
                    this.currentLoopArr.forEach(item => {
                        unsubscribebySubLoopUrl(item.switchStatus)
                    })
                this.getCurrentDeviceInfo()
                if (this.currentDevice.deviceTypeId == 14) {
                    GetLoopsByDeviceId({
                        deviceId: this.currentDevice.deviceInfo.deviceId
                    }).then((json) => {
                        this.currentLoopArr = json.data.data.devices.filter(item => item.loopType != 'BREAKER' )
                        this.currentLoopArr.forEach(item => {
                            subscribebySubLoopUrl(item.switchStatus)
                        })
                        this.currentLoopModelID = json.data.data.devices[0].modelId
                    })
                }
                this.list.forEach(item => {
                    item.children.forEach(item => {
                        if (item.modelId == n) this.$refs.elTree.setCurrentKey(item.id);
                    })
                })
            },
            currentLoopModelID(n, o) {
                this.currentLoopID = this.currentLoopArr.find(item => item.modelId == n).loopId
                this.bus.$emit('changeLoop', this.areaId, this.currentLoopID)
            },
        },
        methods: {
            handleNodeClick(data, node, elem) {
                console.log(data, node, elem)
                this.showDetail = false
                this.showLoopTable = false
                if (node.childNodes.length > 0) {
                    // this.$refs.elTree.setCurrentKey(node.childNodes[0].data.id);
                    // this.$emit('showDevice', data.label, node.childNodes[0].data.deviceInfo)
                } else {
                    this.modelId = Number(data.deviceInfo.modelId)
                    this.$emit('showDevice', node.parent.data.label, data.deviceInfo)
                }
            },
            getType(node) {
                return TYPE[node.data.deviceInfo.deviceTypeId]
            },
            nodeExpand(data, node, element) {
                this.height = 4100
            },
            nodeCollapse() {
                this.$nextTick(() => {
                    this.$refs.elTree.store._getAllNodes().every(item => item.expanded == false) ?
                        this.list.length < 3 ? this.height = 1700 : 2200 : null
                })
            },
            collapseAll() {
                for (var i = 0; i < this.$refs.elTree.store._getAllNodes().length; i++) {
                    this.$refs.elTree.store._getAllNodes()[i].expanded = false;
                }
                this.list.length < 3 ? this.height = 1700 : 2200
            },
            getCurrentDeviceInfo() {
                let current = this.allDeviceModelID.find(item => item.modelId == this.modelId)
                this.currentDevice.deviceInfo = current.deviceInfo
                this.currentDevice.deviceTypeId = current.deviceInfo.deviceTypeId
                this.currentDevice.modelId = current.deviceInfo.modelId
                this.currentDevice.deviceImg = current.deviceInfo.deviceImg
                this.currentDevice.deviceName = current.deviceInfo.deviceName
                this.currentDevice.deviceClassName = current.deviceInfo.deviceClassName
                this.currentDevice.deviceModelName = current.deviceInfo.deviceModelName
                this.currentDevice.deviceDetails = JSON.parse(current.deviceInfo.deviceDetails)
            }
        },
    };
</script>

<style lang="less" scoped>
    .detail {
        .w(382);
        .h(448);
        position: fixed;
        top: 1400/108vh;
        left: 4500/192vw;
        background-image: url(../../assets/img/设备参数.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .head {
            width: 100%;
            .h(134);
            margin-top: 200/108vh;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 200/108vh 170/192vw 150/108vh;

            .pic {
                .w(96);
                .h(96);
                background: rgba(13, 148, 255, 0.2);
            }

            .data {
                width: 60%;
                .h(96);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                font-size: 14rem;
                font-family: Source Han Sans CN;
                color: #60A9E2;
            }

            .close {
                .w(17);
                .h(17);
                cursor: pointer;
            }
        }

        .body {
            width: 100%;
            .h(275);
            overflow-y: auto;
        }
    }

    .table_bg {
        ::v-deep.el-tree{
            background: none !important;
        }
        .w(344);
        // border-top: 200/108vh solid transparent;
        // border-bottom: 200/108vh solid transparent;
        // border-right: 200/192vw solid transparent;
        // border-left: 200/192vw solid transparent;
        padding: 200/108vh 200/192vw;
        border-image: url('../../assets/img/背景.9.png');
        // border-image-slice: 10%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        font-size: 18rem;
        color: rgba(255, 255, 255, 1);
        overflow-y: scroll;
        background: rgba(3, 13, 24, 0.75);
        transition: height 0.5s;

        .title {
            width: 100%;
            .h(40);
            min-height: 400/108vh;
            margin-top: -50/108vh;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1rem solid rgba(255, 255, 255, 0.15);

            .title_left {
                .w(105);
                .h(23);
                display: flex;
                flex-direction: row;
                line-height: 230/108vh;

                .icon {
                    .w(25);
                    .h(23);
                    background-image: url('../../assets/img/device_icon.png');
                    background-size: 100% 100%;
                    margin-right: 80/192vw;
                }
            }

            .close {
                .w(21);
                .h(21);
                background-image: url('../../assets/img/收起.png');
                background-size: 100% 100%;
                cursor: pointer;
            }
        }

        .content {
            width: 100%;
            // .h(410);
            max-height: 38vh;
            overflow-y: auto;

            

        }
    }

    .loop {
        .w(300);
        .h(300);
        position: fixed;
        bottom: 1200/108vh;
        right: 4800/192vw;
        background: url('../../assets/img/loopTable.png');
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 200/108vh 0 300/108vh 100/192vw;
        color: #fff;

        .close {
            .w(15);
            .h(15);
            position: absolute;
            right: 15rem;
            top: 10rem;
            cursor: pointer;
        }

        .lineContainer {
            width: 90%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            overflow-y: scroll;

            .active {
                color: #60A9E2;
            }

            .loopLine {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                // min-height: 400/108vh;
                width: 95%;
                font-size: 18rem;
                cursor: pointer;
                margin-bottom: 100/108vh;
                line-height: 1.5;
            }

            span {
                width: 70%;
            }
        }
    }

    .body::-webkit-scrollbar {
        display: none;
        // width: 50/192vw;
        // height: 1px;
    }

    .body::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    .content::-webkit-scrollbar {
        width: 30/192vw;
        height: 1px;
    }

    .lineContainer::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    .lineContainer::-webkit-scrollbar {
        width: 30/192vw;
        height: 1px;
    }

    .content::-webkit-scrollbar-thumb {
        border-radius: 3px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    .table_bg::-webkit-scrollbar {
        display: none;
        // width: 50/192vw;
        // height: 1px;
    }

    .table_bg::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }
</style>